// Split header: compact once the page is scrolled; full-screen menu on small screens.
export function initHeader() {
    const header = document.querySelector('.site-header');
    const toggle = header?.querySelector('.mobile-menu');
    const nav = header?.querySelector('.site-header__nav');
    if (!header) return;

    let ticking = false;
    const update = () => {
        header.classList.toggle('is-compact', window.scrollY > 40);
        ticking = false;
    };
    window.addEventListener('scroll', () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }, { passive: true });
    update();

    const setOpen = (open) => {
        header.classList.toggle('is-open', open);
        document.documentElement.classList.toggle('menu-open', open);
        toggle?.setAttribute('aria-expanded', String(open));
        // The open menu covers the page: what lies behind it is out of reach for Tab and screen readers.
        // (the skip links and the consent banner sit outside #page, so both levels).
        [...header.parentElement.children, ...document.body.children].forEach((el) => {
            if (el !== header && !el.contains(header) && el.tagName !== 'SCRIPT') el.inert = open;
        });
    };

    toggle?.addEventListener('click', () => setOpen(!header.classList.contains('is-open')));

    nav?.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link) return;
        if (link.getAttribute('href') === '#') {
            event.preventDefault();
            return;
        }
        setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (header.classList.contains('is-open')) {
            setOpen(false);
            toggle?.focus();
            return;
        }
        // Desktop dropdown (opens on hover and focus): Escape closes it, focus goes back to its parent link.
        const item = document.activeElement?.closest('.menu-item-has-children') || nav?.querySelector('.menu-item-has-children:hover');
        if (!item) return;
        item.classList.add('is-dismissed');
        if (item.contains(document.activeElement)) item.querySelector('a')?.focus();
    });
    nav?.querySelectorAll('.menu-item-has-children').forEach((item) => {
        const reset = () => item.classList.remove('is-dismissed');
        item.addEventListener('mouseleave', reset);
        item.addEventListener('focusout', (event) => {
            if (!item.contains(event.relatedTarget)) reset();
        });
    });
}
